module.exports = __webpack_public_path__ + "img/Get-Started@2x.3b07477d.png";